
/* injects from baggage-loader */
require('./style.scss');

import React, { useEffect } from 'react'
import { connect } from 'react-redux'

import { SetLoyalCardInputActive } from '../../../actions/terminal'
import placeCardPic from '../../../images/placeCard.png'
import { t } from '../../../helpers/translator'
import { ClosePopup } from '../../../actions/ui'

const LoyalCardInputPopup = ({ dispatch }) => {
    useEffect(() => {
        dispatch(SetLoyalCardInputActive(true))

        return () => {
            dispatch(SetLoyalCardInputActive(false))
        }
    }, [])

    return (
        <div className='place-card-container'>
            <p className='place-card-title'>{t("Apply Loyalty Card")}</p>
            <p className='place-card-sub-title'>{t("Please scan your loyalty card.")}</p>
            <img alt='place-card' src={placeCardPic}/>
            <button
                className='button-view-normal-m cancel'
                onClick={() => dispatch(ClosePopup())}
            >
                Cancel
            </button>
        </div>
    )
}

export default connect()(LoyalCardInputPopup)